import { toast } from "sonner";
import { FormDialog } from "./FormDialog";

export const ReasonDialog = ({ title, onClose, onSubmit, testid = "reason" }) => (
  <FormDialog open onOpenChange={onClose} title={title} testid={`${testid}-dialog-form`} initial={{}}
    fields={[{ name: "reason", label: "Reason (at least 3 characters)", required: true, minLength: 3 }]}
    onSubmit={(f) => {
      const r = (f.reason || "").trim();
      if (r.length < 3) { toast.error("Please give a reason of at least 3 characters"); return false; }
      return onSubmit(r);
    }} />
);
